import { getIcons } from "_helpers";
import { useEffect, useState } from "react";
import { AlertsSidePanelTableViariables } from "views/portal/alerts";
import { useSelector } from "react-redux";

export { LogsSidePanel };

/**
 * Contenu de la div lattérale pour la page alertes
 * @returns 
 */
function LogsSidePanel() {

    const { data } = useSelector((state) => state.sidePanel);

    const [evtDate, setEvtDate] = useState('');

    useEffect(() => {
        if(data) {           

            if (data.TIME_DIAGNOSTIC_LOGGER){
                // construction de la date au bon format
                const [datePart, timePart] = data.TIME_DIAGNOSTIC_LOGGER.split(' ');
                const [hours, minutes] = timePart.split(':');
                const formattedDate = `${datePart} à ${hours}:${minutes}`;

                setEvtDate(formattedDate);
            }
        }    
    }, [data])


    return (
        <>
            {data && 
                <div>
                    <div className="side-panel-date">
                        <img src={getIcons('accessTimeOutlinedGrey')} alt='icone parametres' />
                        Date et heure TIGR: {evtDate}
                    </div> 
                    <div className="my-4">
                        {<AlertsSidePanelTableViariables maxHeight={'75vh'} showType={false}/>}
                    </div>
                </div>
            }
        </>
    )
}
